import {
  Chat,
  QuestionAnswer,
  Groups,
  Dashboard,
  ShoppingCart,
  NotStarted,
  EmojiEvents,
  BrunchDining,
  OndemandVideo,
  Description,
  AutoStories,
  School,
} from '@mui/icons-material';
import RestaurantRoundedIcon from '@mui/icons-material/RestaurantRounded';
import React from 'react';
import { getClientHost } from '../../lib/constants/constants';
import DietIdIcon from '../DietIdIcon';
const patient_menuItems = [
  {
    icon: <Dashboard />,
    tooltip: 'Dashboard',
    text: 'Dashboard',
    slug: 'dashboard',
    category: 'dashboard',
    path: '/dashboard',
  },
  {
    icon: <RestaurantRoundedIcon />,
    tooltip: 'Orders',
    text: 'Orders',
    slug: 'orders',
    legacy: true,
    category: 'orders',
    path: '/orders/details',
    type: 'button',
  },
  {
    icon: <NotStarted />,
    tooltip: 'New Assessment',
    text: 'New Assessment',
    slug: 'assessment',
    legacy: true,
    category: 'assessment',
    url: getClientHost() + '/assessment/start',
    type: 'button',
  },
  // {
  //     icon: <ShoppingCart />,
  //     tooltip: 'Orders',
  //     text: 'Orders',
  //     slug: 'orders',
  //     category: 'orders',
  //     path: '/orders',
  // },
  {
    icon: <School />,
    tooltip: 'Browse the Education Center',
    text: 'Education',
    slug: 'learn',
    category: 'learn',
    path: '/learn',
    children: [
      {
        icon: <AutoStories />,
        text: 'Guidebooks',
        path: '/learn/guidebooks',
      },
      {
        icon: <Description />,
        text: 'Articles',
        path: '/learn/articles',
      },
      {
        icon: <OndemandVideo />,
        text: 'Videos',
        path: '/learn/videos',
      },
      {
        icon: <BrunchDining />,
        text: 'Recipes',
        path: '/learn/recipes',
      },
    ],
  },
  // {
  //     icon: <Groups />,
  //     tooltip: 'Community',
  //     text: 'Community',
  //     slug: 'community',
  //     category: 'community',
  //     path: '/community',
  //     children: [
  //         {
  //             icon: <QuestionAnswer />,
  //             text: 'Community Questions',
  //             path: '/community/questions',
  //         },
  //         {
  //             icon: <EmojiEvents />,
  //             text: 'Wins',
  //             path: '/community/wins',
  //         }
  //     ]
  // },
  // {
  //     icon: <Chat />,
  //     tooltip: 'Inbox',
  //     text: 'Inbox',
  //     slug: 'inbox',
  //     category: 'inbox',
  //     path: '/inbox',
  // },
  {
    icon: <DietIdIcon />,
    tooltip: 'Your Diet Quality',
    text: 'Your Diet Quality',
    slug: 'quality',
    category: 'quality',
    path: '/quality',
    disabled: false,
    type: 'button',
  },
];

export default patient_menuItems;
